import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=2e8b100b&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8b100b",
  null
  
)

export default component.exports